/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TopicMapperListEditor.vue?vue&type=template&id=19208898&scoped=true"
import script from "./TopicMapperListEditor.vue?vue&type=script&lang=js"
export * from "./TopicMapperListEditor.vue?vue&type=script&lang=js"
import style0 from "./TopicMapperListEditor.vue?vue&type=style&index=0&id=19208898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19208898",
  null
  
)

export default component.exports